import { Link } from "@magnetic/link";
import { Icon } from "@magnetic/nav";
import { Popover } from "@magnetic/popover";

import {
  getMockShellArrowKeysHelp,
  getMockShellCtrlKeysHelp,
  getMockShellHelp,
  getMockShellMetaKeysHelp
} from "./mockShellUtils";

const commands = getMockShellHelp();
const ctrlCmds = getMockShellCtrlKeysHelp();
const arrowCmds = getMockShellArrowKeysHelp();
const metaCmds = getMockShellMetaKeysHelp();
interface DisplayCommandsProps {
  readonly cmds: Record<string, string>;
  readonly prefix?: string;
}
const DisplayCommands = ({ cmds, prefix }: DisplayCommandsProps) => {
  return Object.entries(cmds).map(([cmd, desc]) => (
    <div className="cmd-container" key={cmd}>
      <div className="shell-cmd">
        {prefix && (
          <>
            <span className="cmd">{prefix}</span>+
          </>
        )}
        <span className="cmd">{cmd}</span>
      </div>
      <div className="cmd-desc">{desc}</div>
    </div>
  ));
};

export const MockShellHelp = () => {
  return (
    <Popover
      size="lg"
      placement="bottom-end"
      title={
        <>
          <DisplayCommands cmds={commands} />
          <DisplayCommands cmds={ctrlCmds} prefix="Ctrl" />
          <DisplayCommands cmds={arrowCmds} />
          <DisplayCommands cmds={metaCmds} prefix="Meta" />
        </>
      }
    >
      <Link className="hover-target">
        <Icon kind="help" />
      </Link>
    </Popover>
  );
};
